import {
  Briefcase,
  Menu,
  X,
  User,
  LogOut,
  ChevronDown,
  Bell,
  BookOpen,
  GraduationCap,
  Sparkles,
  Compass,
  Rocket,
  Heart,
  Key,
} from "lucide-react";
import freshmentLogo from "./../assets/icons/freshmentLogo.svg";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoginPage from "../pages/auth/LoginPage";
import SignupPage from "../pages/auth/SignupPage";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isSignupOpen, setIsSignupOpen] = useState(false);

  // Mobile accordion states
  const [mobileJobsOpen, setMobileJobsOpen] = useState(false);
  const [mobilePrepareOpen, setMobilePrepareOpen] = useState(false);

  // to re render when logged in from job description
  const [user, setUser] = useState(null);

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("Freshment_user_data");
    window.location.href = "/";
  };

  useEffect(() => {
    const handleLogin = () => {
      const data = localStorage.getItem("Freshment_user_data");
      setUser(data ? JSON.parse(data) : null);
    };

    window.addEventListener("userLoggedIn", handleLogin);
    return () => window.removeEventListener("userLoggedIn", handleLogin);
  }, []);

  const userData = localStorage.getItem("Freshment_user_data");
  const userdetail = userData ? JSON.parse(userData) : null;

  return (
    <>
      <div className="bg-slate-900 text-white py-2 px-4 relative z-50">
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-xs xsm:text-[11px] font-bold tracking-wide uppercase text-center">
          <span className="inline-flex items-center gap-1 bg-blue-600 text-white px-2 py-0.5 rounded text-[10px]">
            <Heart className="w-3 h-3 fill-current" /> Mission
          </span>
          <span className="opacity-90">
            Boosting Employment & Bridging Education to Employment 🇮🇳
          </span>
        </div>
      </div>

      <nav
        className="bg-white sticky top-0 shadow-sm border-b border-gray-100"
        style={{ zIndex: "1000" }}
      >
        <div className="max-w-7xl mx-auto px-8 xl:px-6 xsm:px-4">
          <div className="flex justify-between h-16">
            {/* Logo */}
            <div
              className="flex-shrink-0 flex items-center gap-2 cursor-pointer"
              onClick={() => navigate("/")}
            >
              {/* <div className="bg-blue-600 p-1.5 rounded-lg">
                <Briefcase className="h-6 w-6 text-white" />
              </div>
              <span className="font-bold text-2xl text-slate-900 tracking-tight">
                Freshment
              </span> */}
              <img
                loading="lazy"
                src={freshmentLogo}
                alt="menu"
                className="w-[162px] h-[36px]"
              />

            </div>

            {/* Desktop Menu */}
            <div className="flex sm:hidden items-center space-x-6">
              {/* Jobs Dropdown - REDESIGNED */}
              <div className="relative group h-full flex items-center">
                <button className="flex items-center gap-1 text-gray-600 group-hover:text-blue-600 font-medium transition h-full">
                  Jobs{" "}
                  <ChevronDown className="w-4 h-4 transition-transform group-hover:rotate-180" />
                </button>

                {/* Dropdown Menu */}
                <div className="absolute top-[calc(100%-0.5rem)] left-0 w-72 bg-white border border-slate-100 shadow-2xl rounded-2xl p-2 hidden group-hover:block animate-in fade-in slide-in-from-top-2 duration-200 ring-1 ring-slate-900/5">
                  <div className="grid gap-1">
                    <div
                      onClick={() => {
                        navigate("/freshers-job");
                      }}
                      className="flex items-start gap-3 cursor-pointer p-3 rounded-xl hover:bg-slate-50 transition-colors group/item"
                    >
                      <div className="w-10 h-10 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover/item:bg-blue-600 group-hover/item:text-white transition-colors">
                        <Sparkles className="w-5 h-5" />
                      </div>
                      <div>
                        <div className="text-sm font-bold text-slate-900 group-hover/item:text-blue-600">
                          Fresher Jobs
                        </div>
                        <div className="text-xs text-slate-500 font-medium mt-0.5">
                          For 2026/27 Batch
                        </div>
                      </div>
                    </div>

                    <div
                      onClick={() => {
                        navigate("/explore-job");
                      }}
                      className="flex items-start gap-3 cursor-pointer p-3 rounded-xl hover:bg-slate-50 transition-colors group/item"
                    >
                      <div className="w-10 h-10 bg-purple-50 text-purple-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover/item:bg-purple-600 group-hover/item:text-white transition-colors">
                        <Compass className="w-5 h-5" />
                      </div>
                      <div>
                        <div className="text-sm font-bold text-slate-900 group-hover/item:text-purple-600">
                          Explore Jobs
                        </div>
                        <div className="text-xs text-slate-500 font-medium mt-0.5">
                          ByCategory & Skills
                        </div>
                      </div>
                    </div>

                    <div
                      onClick={() => {
                        navigate("/internship");
                      }}
                      className="flex items-start gap-3 cursor-pointer p-3 rounded-xl hover:bg-slate-50 transition-colors group/item"
                    >
                      <div className="w-10 h-10 bg-orange-50 text-orange-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover/item:bg-orange-600 group-hover/item:text-white transition-colors">
                        <Rocket className="w-5 h-5" />
                      </div>
                      <div>
                        <div className="text-sm font-bold text-slate-900 group-hover/item:text-orange-600">
                          Internships
                        </div>
                        <div className="text-xs text-slate-500 font-medium mt-0.5">
                          Start your career
                        </div>
                      </div>
                    </div>
                    <div
                      onClick={() => {
                        navigate("/government-job");
                      }}
                      className="flex items-start gap-3 cursor-pointer p-3 rounded-xl hover:bg-slate-50 transition-colors group/item"
                    >
                      <div className="w-10 h-10 bg-orange-50 text-orange-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover/item:bg-orange-600 group-hover/item:text-white transition-colors">
                        <Rocket className="w-5 h-5" />
                      </div>
                      <div>
                        <div className="text-sm font-bold text-slate-900 group-hover/item:text-orange-600">
                          Government jobs
                        </div>
                        <div className="text-xs text-slate-500 font-medium mt-0.5">
                          Explore Goverment Jobs
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Colleges (Renamed from Services) */}
              <button
                onClick={() => navigate("/edu-connect")}
                className="text-gray-600 hover:text-blue-600 font-medium transition"
              >
                Colleges
              </button>

              {/* Startup Odisha */}
              <button
                onClick={() => navigate("/startup-odisha")}
                className="text-gray-600 hover:text-blue-600 font-medium transition"
              >
                Startup Odisha
              </button>

              {/* About Us */}
              <button
                onClick={() => navigate("/about")}
                className="text-gray-600 hover:text-blue-600 font-medium transition"
              >
                About Us
              </button>

              {/* Prepare Dropdown */}
              <div className="relative group h-full flex items-center">
                <button className="flex items-center gap-1 text-gray-600 group-hover:text-blue-600 font-medium transition h-full">
                  Prepare{" "}
                  <ChevronDown className="w-4 h-4 transition-transform group-hover:rotate-180" />
                </button>
                <div className="absolute top-[calc(100%-0.5rem)] left-0 w-60 bg-white border border-slate-100 shadow-xl rounded-xl py-2 hidden group-hover:block animate-in fade-in slide-in-from-top-2 duration-200">
                  <div
                    onClick={() => {
                      navigate("/study-material");
                    }}
                    className="px-4 py-3 text-sm text-gray-600 hover:bg-slate-50 hover:text-blue-600 font-medium cursor-pointer flex items-center gap-3"
                  >
                    <BookOpen className="w-4 h-4" /> Study Materials
                  </div>
                  <div
                    onClick={() => {
                      navigate("/current-affairs");
                    }}
                    className=" px-4 py-3 text-sm text-gray-600 hover:bg-slate-50 hover:text-blue-600 font-medium cursor-pointer flex items-center gap-3"
                  >
                    <GraduationCap className="w-4 h-4" /> Current Affairs
                  </div>
                </div>
              </div>

              {/*<button
                onClick={() => {
                  setIsOpen(false);
                  navigate("/post-your-job");
                }}
                className="text-gray-600 hover:text-blue-600 font-medium transition"
              >
                Post Your Job
              </button> */}

              <div className="flex items-center space-x-3 ml-4" onMouseEnter={() => setIsProfileMenuOpen(true)} onMouseLeave={() => setIsProfileMenuOpen(false)}>
                {userdetail ? (
                  <div className="relative">
                    <button
                      // onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
                      className="flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-full pl-1 pr-3 py-1 hover:bg-slate-100 transition"
                    >
                      <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center border border-blue-200">
                        <User className="w-4 h-4 text-blue-600" />
                      </div>
                      <span className="text-sm font-bold text-slate-700">
                        {userdetail?.data?.name}
                      </span>
                      <ChevronDown className="w-3.5 h-3.5 text-slate-400" />
                    </button>

                    {/* Profile Dropdown */}
                    {isProfileMenuOpen && (
                      <div
                        className="absolute right-0  w-56 bg-white rounded-xl shadow-xl border border-slate-100 py-1"
                        style={{ zIndex: "1000" }}
                      >
                        <button
                          onClick={() => {
                            setIsProfileMenuOpen(false);
                            navigate("/profile");
                          }}
                          className="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50 hover:text-blue-600 flex items-center gap-2"
                        >
                          <User className="w-4 h-4" /> My Profile
                        </button>

                        {/* Industry Courses */}
                        <button
                          onClick={() => {
                            setIsProfileMenuOpen(false);
                            navigate("/industry-courses");
                          }}
                          className="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50 hover:text-blue-600 flex items-center gap-2"
                        >
                          <BookOpen className="w-4 h-4 text-orange-500" /> Industry Courses
                          <span className="ml-auto bg-orange-500 text-white text-[10px] font-bold px-1.5 rounded-full">NEW</span>
                        </button>

                        {/* Change Password */}
                        <button
                          onClick={() => {
                            setIsProfileMenuOpen(false);
                            navigate("/change-password");
                          }}
                          className="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50 hover:text-blue-600 flex items-center gap-2"
                        >
                          <Key className="w-4 h-4" /> Change Password
                        </button>

                        {/* College Job Alerts */}
                        <button
                          onClick={() => {
                            setIsProfileMenuOpen(false);
                            navigate("/CollegeAlertsPage");
                          }}
                          className="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50 hover:text-blue-600 flex items-center gap-2"
                        >
                          <Bell className="w-4 h-4" /> Campus Job Alerts
                          <span className="ml-auto bg-red-500 text-white text-[10px] font-bold px-1.5 rounded-full">
                            3
                          </span>
                        </button>

                        <div className="border-t border-slate-100 my-1"></div>
                        <button
                          onClick={() => {
                            setIsProfileMenuOpen(false);
                            handleLogout();
                          }}
                          className="w-full text-left px-4 py-2.5 text-sm font-medium text-red-600 hover:bg-red-50 flex items-center gap-2"
                        >
                          <LogOut className="w-4 h-4" /> Logout
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    <button
                      onClick={() => setIsLoginOpen(true)}
                      className="text-blue-600 font-semibold px-4 py-2 border border-blue-200 rounded-full hover:bg-blue-50 transition"
                    >
                      Login
                    </button>
                    <a
                      href="https://talentconnect.freshmentapp.com/register"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-blue-600 text-white font-semibold px-5 py-2 rounded-full hover:bg-blue-700 shadow-md transition transform hover:-translate-y-0.5 inline-block"
                    >
                      Employer? Post Free Job
                    </a>
                  </>
                )}
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="items-center hidden sm:flex">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none"
              >
                {isOpen ? (
                  <X className="h-6 w-6" />
                ) : (
                  <Menu className="h-6 w-6" />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="hidden sm:block bg-white border-t border-gray-100 max-h-[80vh] overflow-y-auto">
            <div className="px-3 xsm:px-2 pt-2 pb-3 space-y-1">
              {/* Mobile Jobs Menu */}
              <div>
                <button
                  onClick={() => setMobileJobsOpen(!mobileJobsOpen)}
                  className="flex items-center justify-between w-full px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50"
                >
                  Jobs{" "}
                  <ChevronDown
                    className={`w-4 h-4 transition-transform ${mobileJobsOpen ? "rotate-180" : ""}`}
                  />
                </button>
                {mobileJobsOpen && (
                  <div className="pl-4 space-y-1 bg-slate-50/50 rounded-lg my-1 py-1">
                    <div
                      onClick={() => {
                        setIsOpen(false);
                        navigate("/freshers-job");
                      }}
                      className="flex items-center gap-3 px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-white rounded-md mx-1"
                    >
                      <Sparkles className="w-4 h-4" /> Fresher Jobs
                    </div>
                    <div
                      onClick={() => {
                        setIsOpen(false);
                        navigate("/explore-job");
                      }}
                      className="flex items-center gap-3 px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-white rounded-md mx-1"
                    >
                      <Compass className="w-4 h-4" /> Explore Jobs
                    </div>
                    <div
                      onClick={() => {
                        setIsOpen(false);
                        navigate("/internship");
                      }}
                      className="flex items-center gap-3 px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-white rounded-md mx-1"
                    >
                      <Rocket className="w-4 h-4" /> Internships
                    </div>
                    <div
                      onClick={() => {
                        setIsOpen(false);
                        navigate("/government-job");
                      }}
                      className="flex items-center gap-3 px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-white rounded-md mx-1"
                    >
                      <Rocket className="w-4 h-4" /> Government Jobs
                    </div>
                  </div>
                )}
              </div>

              <button
                onClick={() => {
                  setIsOpen(false);
                  navigate("/edu-connect");
                }}
                className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50"
              >
                Colleges
              </button>

              <button
                onClick={() => {
                  setIsOpen(false);
                  navigate("/startup-odisha");
                }}
                className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50"
              >
                Startup Odisha
              </button>

              <button
                onClick={() => {
                  setIsOpen(false);
                  navigate("/about");
                }}
                className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50"
              >
                About Us
              </button>

              {/* Mobile Prepare Menu */}
              <div>
                <button
                  onClick={() => setMobilePrepareOpen(!mobilePrepareOpen)}
                  className="flex items-center justify-between w-full px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50"
                >
                  Prepare{" "}
                  <ChevronDown
                    className={`w-4 h-4 transition-transform ${mobilePrepareOpen ? "rotate-180" : ""}`}
                  />
                </button>
                {mobilePrepareOpen && (
                  <div className="pl-4 space-y-1 bg-slate-50/50 rounded-lg my-1 py-1">
                    <button
                      onClick={() => {
                        setIsOpen(false);
                        navigate("/current-affairs");
                      }}
                      className="block  text-left px-3 py-2 text-sm text-gray-600 hover:text-blue-600"
                    >
                      Current Affairs
                    </button>
                    <button
                      onClick={() => {
                        setIsOpen(false);
                        navigate("/study-material");
                      }}
                      className="block text-left px-3 py-2 text-sm text-gray-600 hover:text-blue-600"
                    >
                      Study Materials
                    </button>
                  </div>
                )}
              </div>

              <div className="pt-4 pb-2 border-t border-gray-100 mt-2">
                {userdetail ? (
                  <>
                    <div className="flex items-center gap-3 px-3 mb-4">
                      <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center border border-blue-200">
                        <User className="w-5 h-5 text-blue-600" />
                      </div>
                      <div>
                        <div className="font-bold text-slate-900">
                          {userdetail?.data?.name}
                        </div>
                        <div className="text-xs text-slate-500">
                          {userdetail?.data?.email}
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        setIsOpen(false);
                        navigate("/profile");
                      }}
                      className="w-full text-left block px-3 py-3 rounded-lg text-base font-medium text-slate-700 hover:bg-slate-50 mb-1"
                    >
                      <User className="w-4 h-4 inline mr-2" /> My Profile
                    </button>

                    {/* Industry Courses */}
                    <button
                      onClick={() => {
                        setIsOpen(false);
                        navigate("/industry-courses");
                      }}
                      className="w-full text-left block px-3 py-3 rounded-lg text-base font-medium text-slate-700 hover:bg-slate-50 mb-1"
                    >
                      <BookOpen className="w-4 h-4 inline mr-2 text-orange-500" /> Industry Courses
                      <span className="ml-auto bg-orange-500 text-white text-[10px] font-bold px-1.5 rounded-full">NEW</span>
                    </button>

                    {/* Change Password */}
                    <button
                      onClick={() => {
                        setIsOpen(false);
                        navigate("/change-password");
                      }}
                      className="w-full text-left block px-3 py-3 rounded-lg text-base font-medium text-slate-700 hover:bg-slate-50 mb-1"
                    >
                      <Key className="w-4 h-4 inline mr-2" /> Change Password
                    </button>

                    {/* Mobile Menu Alert Item */}
                    <button
                      onClick={() => {
                        setIsOpen(false);
                        navigate("/CollegeAlertsPage");
                      }}
                      className="w-full text-left block px-3 py-3 rounded-lg text-base font-medium text-slate-700 hover:bg-slate-50 mb-1"
                    >
                      <Bell className="w-4 h-4 inline mr-2" /> Campus Job
                      Alerts
                      <span className="ml-2 bg-red-500 text-white text-[10px] font-bold px-1.5 rounded-full align-middle">
                        3
                      </span>
                    </button>

                    <button
                      onClick={() => {
                        handleLogout();
                        setIsOpen(false);
                      }}
                      className="w-full text-left block px-3 py-3 rounded-lg text-base font-medium text-red-600 hover:bg-red-50"
                    >
                      <LogOut className="w-4 h-4 inline mr-2" /> Logout
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => {
                        setIsOpen(false);
                        setIsLoginOpen(true);
                      }}
                      className="w-full font-bold text-left block px-3 py-2 text-base text-blue-600 hover:bg-gray-50"
                    >
                      Candidate Login
                    </button>
                    <a
                      href="https://talentconnect.freshmentapp.com/register"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full mt-2 block px-3 py-3 text-center text-base font-bold bg-blue-600 text-white rounded-md"
                    >
                      Post Job for Free
                    </a>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Login Modal */}
      {isLoginOpen && (
        <LoginPage
          onBack={() => setIsLoginOpen(false)}
          onSignupClick={() => {
            setIsLoginOpen(false);
            setIsSignupOpen(true);
          }}
        />
      )}

      {/* Signup Modal */}
      {isSignupOpen && (
        <SignupPage
          onBack={() => setIsSignupOpen(false)}
          onLogin={() => {
            setIsSignupOpen(false);
            setIsLoginOpen(true);
          }}
        />
      )}
    </>
  );
}
